import { render, staticRenderFns } from "./personStatistic.vue?vue&type=template&id=6b6ae9ce"
import script from "./personStatistic.vue?vue&type=script&lang=js"
export * from "./personStatistic.vue?vue&type=script&lang=js"
import style0 from "./personStatistic.vue?vue&type=style&index=0&id=6b6ae9ce&prod&rel=stylesheet%2Fscss&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports